module.exports = __webpack_public_path__ + "static/settings-currency-fa74158d8b8635b3d0ef794d4070a008.png";